import { render, staticRenderFns } from "./DebtorsFilters.vue?vue&type=template&id=532c51f9&"
import script from "./DebtorsFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DebtorsFilters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DebtorsFilters.vue?vue&type=style&index=0&id=532c51f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports